import React from 'react';
import { useFragment } from 'react-relay';
import { graphql } from 'relay-runtime';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import type { src_issueTableHideDoneToggle_HideDoneItemsToggle$key } from './__generated__/src_issueTableHideDoneToggle_HideDoneItemsToggle.graphql';
import { HideDoneItemsToggle as HideDoneItemsToggleWithoutErrorBoundary } from './ui/HideDoneItemsToggle.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

export type props = {
	isSavedViewsEnabled: boolean;
	onChangeHideDone: (isHideDoneEnabled: boolean) => void;
	viewResult: src_issueTableHideDoneToggle_HideDoneItemsToggle$key;
	onResetSelectedIssues?: () => void;
};

export const HideDoneItemsToggle = (props: props) => {
	const viewResultData = useFragment<src_issueTableHideDoneToggle_HideDoneItemsToggle$key>(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment src_issueTableHideDoneToggle_HideDoneItemsToggle on JiraIssueSearchViewMetadata
			@argumentDefinitions(isSavedViewsEnabled: { type: "Boolean!" }) {
				...HideDoneItemsToggle
					@arguments(staticViewInput: $staticViewInput, isSavedViewsEnabled: $isSavedViewsEnabled)
			}
		`,
		props.viewResult,
	);

	return (
		<JSErrorBoundary
			fallback="unmount"
			id="issue-table-hide-done-toggle"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
		>
			<HideDoneItemsToggleWithoutErrorBoundary
				isSavedViewsEnabled={props.isSavedViewsEnabled}
				viewResult={viewResultData}
				onChangeHideDone={props.onChangeHideDone}
				onResetSelectedIssues={props.onResetSelectedIssues}
			/>
		</JSErrorBoundary>
	);
};
